import { mdiGog, mdiMicrosoftXbox, mdiHelp, mdiSteam, mdiUbisoft, } from "@mdi/js";
import React from "react";
import { nxmElectronicArts, nxmEpicGames, } from "../../../ui/icon-paths";
import { joinClasses } from "../../../ui/utils/joinClasses";
import { useGameImage } from "./utils";
// Fallback for stores without specific icons
const _DEFAULT_STORE_ICON = mdiHelp;
// Map store IDs to icon paths
// Since we can have custom game stores,
// we should provide for the IGameStore interface to
// optionally specify its own icon in the future
const _STORE_ICONS = {
    steam: mdiSteam,
    epic: nxmEpicGames,
    gog: mdiGog,
    xbox: mdiMicrosoftXbox,
    origin: nxmElectronicArts,
    uplay: mdiUbisoft,
};
/** Deterministic hue from a string, for the letter-avatar background. */
function stringToHue(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return Math.abs(hash) % 360;
}
export const GameButton = ({ cacheKey, isActive, preferred, sources = [], store: _store, title, ...props }) => {
    // TODO: Re-enable store icon
    // const storeIcon = _store ? (STORE_ICONS[_store] ?? DEFAULT_STORE_ICON) : null;
    const { src, exhausted, onError, onLoad } = useGameImage(cacheKey, sources, preferred);
    return (React.createElement("button", { className: joinClasses("group relative size-12 shrink-0 overflow-hidden rounded-lg", { "outline-2 outline-offset-2 outline-neutral-strong focus-visible:outline-info-subdued": isActive }), title: title, ...props },
        exhausted ? (React.createElement("span", { className: "absolute inset-0 flex items-center justify-center text-xl font-bold text-white", style: {
                backgroundColor: `hsl(${stringToHue(title ?? "")}, 40%, 35%)`,
            } }, title?.charAt(0)?.toUpperCase() ?? "?")) : (React.createElement("img", { alt: "", className: "absolute inset-0 size-full object-cover", src: src, onError: onError, onLoad: onLoad })),
        React.createElement("span", { className: joinClasses("absolute inset-0 z-1 rounded-lg transition-colors", {
                "border border-stroke-weak group-hover:border-2 group-hover:border-neutral-strong group-hover:bg-translucent-200": !isActive,
            }) })));
};
